import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { resolveMagicLink } from '@/actions'
import { useAppDispatch } from '@/store'

export const useCustomTokenFromMagicLink = () => {
    const dispatch = useAppDispatch()

    const { identifier } = useParams<{ identifier: string }>()

    const [customToken, setCustomToken] = useState<string | null>(null)
    const [redirectUrl, setRedirectUrl] = useState<string | null>(null)
    const [hasError, setHasError] = useState(false)

    useEffect(() => {
        if (!identifier) {
            setHasError(true)
            return
        }

        dispatch(resolveMagicLink({ identifier }))
            .then(({ accessToken, url }) => {
                setCustomToken(accessToken)
                setRedirectUrl(url)
            })
            .catch(() => {
                setHasError(true)
            })
    }, [dispatch, identifier])

    return { redirectUrl, customToken, hasError }
}
